import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import deletemodelpopup from "../../assets/task/deletemodelpopup.svg";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import clockOuticon from "../../assets/task/login_svgrepo-com.svg";
import {
    ApolloError,
    useLazyQuery,
    useMutation,
} from "@apollo/client";
import { useAuth } from "../../context/AuthContext";
import { CREATE_CLOCK_IN_OUT } from "../../api/mutation";
import { showError, showSuccess } from "../common/ToastNotification";
import InputsNew from "../common/InputsNew";
import Loader from "../common/Loader";
import { CHECK_OVERNIGHT_SHIFT } from "../../api/query";
interface PopupProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: any;
}

const clockInSchema = yup.object().shape({
    durationTimeHour: yup
        .number()
        .typeError("")
        .required("")
        .min(0, "Hours should be between 0 to 23")
        .max(23, "Hours should be between 0 to 23"),
    durationTimeMinute: yup
        .number()
        .typeError("")
        .required("")
        .min(0, "Minutes should be between 0 to 59")
        .max(59, "Minutes should be between 0 to 59"),
});


const Popup: React.FC<PopupProps> = ({ isOpen, onClose }) => {
    const now = new Date();
    const pad = (n: any) => String(n).padStart(2, "0");
    const localTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.000Z`;

    // Split raw UTC string manually to avoid timezone shift
    const [datePart, timePart] = localTime.split("T");
    const [hour, minute] = timePart.split(":");

    // Format time (you can also add AM/PM logic if needed)
    const timeString = `${hour}:${minute}`; // "17:40"

    // Format date (2025-06-23)
    const date = new Date(`${datePart}T00:00:00Z`); // Just for getting weekday/month
    const options: Intl.DateTimeFormatOptions = { weekday: "long", day: "numeric", month: "long" };
    const dateString = date.toLocaleDateString("en-US", options).toUpperCase();

    const { userInfo } = useAuth()
    const agencyId = parseInt(userInfo?.agencies?.id);
    const employeeID = userInfo?.employee_id || '';
    const appUserID = userInfo?.app_user_id || ""

    //api
    const [createClockIn, { loading: createClockInLoading }] = useMutation(CREATE_CLOCK_IN_OUT, {
        fetchPolicy: 'no-cache',
    })
    //check night shift
//     const [checkOvernightShift, { data, loading }] = useLazyQuery(
//   CHECK_OVERNIGHT_SHIFT,
//   {
//     fetchPolicy: "no-cache",
//   }
// );

// const checkOvernightShiftStatus = async () => { const response = await checkOvernightShift({ variables: { target_date: localTime, employee_id: parseInt(employeeID), }, }); return ( response.data?.check_overnight_shift?.record ?.is_overnight_shift ?? false ); };
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<any>({
        resolver: yupResolver(clockInSchema),
    });

    const handleKeyDown = (event: any) => {
        const { key } = event;
        // Allow control keys like backspace, delete, arrows, etc.
        if (
            key === "Backspace" ||
            key === "Delete" ||
            key === "ArrowLeft" ||
            key === "ArrowRight" ||
            key === "Tab" ||
            key === "Enter"
        ) {
            return;
        }

        // Prevent non-numeric keys
        if (!/^[0-9]$/.test(key)) {
            event.preventDefault();
        }
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        const paste = event.clipboardData.getData("text");
        if (!/^\d+$/.test(paste)) {
            event.preventDefault();
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("coverflow_hidden_scoll_bdy");

            return () => {
                document.body.classList.remove("coverflow_hidden_scoll_bdy");
            };
        }
    }, [isOpen]);

    const handleCancel = () => {
        onClose();
    };

    async function onSubmit(data: any) {
        // 1. Check whether employee has an overnight shift 
        // const isOvernightShift = await checkOvernightShiftStatus();
        const clockInInput = {
            employees_id: parseInt(employeeID),
            check_in_time: localTime,
            is_check_in: true,
            agencies_id: agencyId,
            checked_by: employeeID,
            minutes: data?.durationTimeMinute,
            hours: data?.durationTimeHour,
            created_by: parseInt(employeeID),
            app_user_id: appUserID,
            // 3. Send overnight flag to clock-in API 
            // is_night_shift: isOvernightShift,
        }

        try {
            const response = await createClockIn({ variables: { input: clockInInput } });

            if (response.data.create_clock_in_out?.errors?.length == 0) {
                onClose()
                showSuccess("Clock In successful")
            }

            if (response.data.create_clock_in_out.errors?.length > 0) {
                showError(response.data.create_clock_in_out.errors[0].messages[0]);
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    if (!isOpen) return null;

    return (
        <>
            <div id="model-main-blg" onClick={(e) => e.stopPropagation()}>
                <div id="inner_loader_dv">
                    {/* <div className="w-[622px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddtask_main"> */}
                    <div className="clockout_time_main w-[480px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddtask_main">
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            className="m-0 flex-1 rounded-radius-radius-lg bg-white border-[1px] border-solid border-surface-border flex flex-col items-center justify-start p-8 mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border"
                        >
                            <div className="relative w-full" onClick={handleCancel}>
                                <img
                                    src={deletemodelpopup}
                                    alt=""
                                    className="cursor-pointer pr-0  mq575:pr-0 mq575:pt-0 w-5 h-5 absolute right-0 top-[-5px]  mq575:top-0 mq575:w-3 mq575:h-3 dark-white-img "
                                    style={{}}
                                    onClick={handleCancel} />
                            </div>
                            <div className="clockout_time_blg  w-full flex justify-center items-center">
                                <div className="grid gap-[8px] p-[10px] text-center">
                                    <h3 className="my-0 dark:text-white">{timeString}</h3>
                                    <h5 className="my-0 dark:text-white">{dateString}</h5>
                                </div>
                            </div>
                            <div className="flex gap-[8px] items-center justify-between w-full">
                                <div className="flex flex-1 ">
                                    <InputsNew
                                        label="Work Duration*"
                                        type="number"
                                        contentPlaceholder="Hours"
                                        onKeyDown={handleKeyDown}
                                        onPaste={handlePaste}
                                        register={{ ...register("durationTimeHour") }}
                                        errorMessage={errors.durationTimeHour}
                                        autoComplete={"off"}
                                    />
                                </div>
                                <div className="flex flex-1 pt-5">
                                    <InputsNew
                                        // label={"Task Name*"}
                                        type="number"
                                        contentPlaceholder="Min"
                                        onKeyDown={handleKeyDown}
                                        onPaste={handlePaste}
                                        register={{ ...register("durationTimeMinute") }}
                                        errorMessage={errors.durationTimeMinute}
                                        autoComplete={"off"}
                                    />
                                </div>
                            </div>
                            {/* <Controller
                            name="Task Date"
                            control={control}
                            render={({ field }) => (
                                <DateSelector
                                    label=" Task Date*"
                                    selectedDate={field.value}
                                    onChange={(date: string | null) => {
                                        field.onChange(date);
                                        setValue("date", date);
                                        trigger("date");
                                    }}
                                    nothideParsedValue={true}
                                    blueIcon={true}
                                    //   maxDate={new Date()}
                                    minDate={new Date()}
                                    error={errors.date?.message}
                                />
                            )}
                        />
                        <InputsNew
                            label={"Task Name*"}
                            type={"textarea"}
                            contentPlaceholder={"Task Name"}
                            onKeyDown={handleAlphaNumeric}
                            onPaste={handlePaste}
                            register={{ ...register("taskName") }}
                            errorMessage={errors.taskName}
                            autoComplete={"off"}
                        /> */}
                            <div className="self-stretch flex flex-row items-center justify-center py-0 pr-0 gap-[8px] mq450:box-border mq950:box-border mq1425:flex-wrap mq1425:box-border">
                                {/* <button
                                className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px]   rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                type="button"
                                onClick={handleCancel}
                            >
                                <div className="relative text-sm font-body-xs-semi-bold text-surface-primary-surface text-center inline-block min-w-[51px]">
                                    Cancel
                                </div>
                            </button> */}
                                <button
                                    className="w-full cursor-pointer [border:none] pxz-spacing-lg bg-surface-primary-surface py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px]   rounded-radiuscomponent-button flex flex-row items-center justify-center box-border gap-[12px] hover:bg-dodgerblue"
                                    type="submit"
                                >
                                    <img src={clockOuticon} alt="" />
                                    <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block min-w-[51px]">
                                        CLOCK IN
                                    </div>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {(createClockInLoading) && (
                <Loader />
            )}
        </>
    );
};

export default Popup;